import React from 'react'
import ButtonUI from '../../widgets/action/ButtonUI'

const FileInputUI = ({fileInput, handleSubmit}) =>
  <form onSubmit={handleSubmit}>
    <input type="file" ref={fileInput} />
    <br />
    <ButtonUI label='Upload' />
  </form>

export default FileInputUI
